import { get } from 'lodash';
import React from 'react';
import { courts } from '@upsolve/shared';

import ImageStaticMap from '../Media/ImageStaticMap';

const CourtsList = ({ district, state }) => {
  if (district == null && state == null) return null;

  const filteredCourts = courts.filter((court) => {
    if (district != null) return court.district.toLowerCase() === district.toLowerCase();
    if (state != null) return court.state.toLowerCase() === state.toLowerCase();
    return false;
  });

  return (
    <div>
      {Array.prototype.map.call(filteredCourts, (court) => (
        <div key={court.name}>
          <p>
            <a href={court.url}>{court.name}</a>
            <br />
            {court.phone}
            <br />
            {get(court, 'address.display')}
          </p>
          <ImageStaticMap
            alt={court.name}
            address={court.address}
          />
        </div>
      ))}
    </div>
  )
}

export default CourtsList;
